import { create } from 'zustand'

/** Global state. We want to render `formDialog` on top (app) level */
export const useGlobalFormDialog = create<{
  formDialog?: React.ReactNode | null
  setFormDialog: (formDialog: React.ReactNode | null) => void
}>(set => ({
  setFormDialog: (formDialog: React.ReactNode | null) => set({ formDialog }),
}))
